<template>
    <div style="color:var(--regpwd-primarytextcolor)">
        <spinner :spinnerOn="loading"></spinner>
        <img src="static/bgi.jpg" alt="" class="splash">
        <div v-if="!inviteSuccess" id="selfRegistration" style="box-shadow: 2px 2px 10px #ccc;">
            <div style="max-width: 800px;margin: auto;padding-top:35px; padding:35px;background: #fff">
                <div class="okta-sign-in-header auth-header">                
                  <img src="static/1200px-Cargill_logo.svg.png" class="auth-org-logo" alt="">                
                  <div data-type="beacon-container" class="beacon-container"></div>      
                </div>
                <div>
                    <div style="text-align:center;padding:10px">
                      <h5> {{user_lang.selfRegFormTitle}} </h5>
                    </div>
                    <div style="padding:10px;">
                        <div class="row">
                            <div class="col-12" style="margin: auto;text-align: left; margin-bottom:10px">
                                <input type="text" v-model="person.firstName" v-bind:placeholder="user_lang.first_name" style="width:100%;height:45px;padding-left:10px;"/>
                            </div>
                            <div class="col-12" style="margin: auto;text-align: left; margin-bottom:10px">
                                <input type="text" v-model="person.lastName" v-bind:placeholder="user_lang.last_name" style="width:100%;height:45px;padding-left:10px;"/>
                            </div>
                            <div class="col-12" style="margin: auto;text-align: left; margin-bottom:10px;">
                                <input type="text" v-model="person.email" v-bind:placeholder="user_lang.enter_email" style="width:100%;height:45px;padding-left:10px;"/>
                            </div>
                            <div class="col-12" style="margin: auto;text-align: left; margin-bottom:10px">
                                <select v-model="person.locale" class="preflang" id="message-text" style="height:39px; width: 100%">          
		                              <option value="" selected>{{user_lang.selectLang}}</option>
                                  <option v-for= "i in lang_def" v-bind:value="i.langCode">{{i.langName}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div id="captcha_container" style="padding:10px;width: 100%;text-align:center;margin:0px auto;">
                        <vue-recaptcha v-bind:sitekey="sitekey" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired" @error="onError" @render="onRender">
                        </vue-recaptcha>
                    </div>
                    <div style="padding-left:10px;">
                        <div class="validation-text" v-if="userValidations !== ''">{{userValidations}}</div>
                    </div>
                    <div style="padding:10px;">
                      <button style="width:100%" @click="validateAndResendInvite()" 
                    v-bind:class="{'disabled': !captchaVerified}">
                        {{user_lang.selfRegister}}</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="inviteSuccess" id="selfRegistrationSucess" style="box-shadow: 2px 2px 10px #ccc;">
          <div style="text-align: center;padding:30px;border-top: 1px solid #ccc;background: #fff;">
              <div style="display: block;text-align:center;"><i class="fa fa-check-circle" style=" font-size:50px; color: var(--theme-primary) "></i></div>
              <div v-if="successCode === 'E0001' || successCode === 'E0002' || successCode === 'E0005'">
                {{user_lang.E0001}}
                <a 
                :href="`mailto:${contactMailId}`"
                v-if="mailCheck"
                >{{user_lang.E0001_1}}</a>
                <a 
                :href="`${contactMailId}`"
                v-if="!mailCheck"
                >{{user_lang.E0001_1}}</a>
                {{user_lang.E0001_2}}
              </div>
              <div v-if="successCode === 'E0003' || successCode === 'STAGED' || successCode === 'PROVISIONED'">
                {{user_lang.E0003}}
                <a 
                :href="`mailto:${contactMailId}`"
                v-if="mailCheck"
                >{{contactMailId}}</a>
                <a 
                :href="`${contactMailId}`"
                v-if="!mailCheck"
                >{{contactMailId}}</a>
                {{user_lang.E0003_1}}
              </div>
              <div v-if="successCode === 'E0004' || successCode === 'ACTIVE'">
                {{user_lang.E0004}}
              </div>
          </div>
        </div>
    </div>
</template>
<script>
  import Spinner from '@/components/Spinner'
  import idmApi from '@/idm-api';
  import VueRecaptcha from 'vue-recaptcha';
  import { locale } from '@/i18n/locale.js'
  import common from '../helpers/common';
  const apiUrl = process.env.API_URL;
  const SITEKEY = process.env.CAPTCHA_SITEKEY;
  const APPIDRECAPTCHAEXCEPTION = process.env.APP_ID_RECAPTCHA_EXCEPTION;
  const GROUPIDRECAPTCHAEXCEPTION = process.env.GROUP_ID_RECAPTCHA_EXCEPTION;
  let environment = process.env.NODE_ENV;
  let brandDetails = "";
  console.log('env=====', environment);
  if (environment === 'production') {
    brandDetails = require('../brand-details.json');
  } else if (environment === 'stage') {
    brandDetails = require('../brand-details-stage.json');
  } else {
    brandDetails = require('../brand-details-dev.json');
  }
  export default {
    created () {
      this.appId = this.getParameterByName('appId', document.location.href);
      this.selfServiceGroup = this.getParameterByName('selfServiceGroup', document.location.href);
      let self = this;
      self.loading = false;
      $(document).on('keypress', 'input', function() {
        self.errorCode = '';
        self.userValidations = '';
      });
      var brand = brandDetails.data.filter(i => i.applicationUrls.indexOf(document.location.host) > -1)
      if (brand[0].brandCode !== '001') {
        self.$router.push({path: '/Login'});
      }
    },
    mounted () {
      this.sendMessageToDatadog(`Self Registration loaded for app - ${this.appId}`);
      this.langCode = this.getParameterByName('lang', document.location.href);
      if (this.langCode !== null) {
        this.user_lang = locale.lang_obj[this.langCode];
        this.updateCaptchaWithLocale();
      }
    },
    data () {
      return {
        appId: '',
        lang_def: locale.lang_def,
        person: {firstName: '', lastName: '', email: '', locale: '', login: ''},
        errorCode: '',
        user_lang: locale.lang_obj['en_US'],
        loading: true,
        userValidations: '',
        captchaVerified: false,
        inviteSuccess: false,
        sitekey: SITEKEY,
        appIdException: APPIDRECAPTCHAEXCEPTION,
        groupIdException: GROUPIDRECAPTCHAEXCEPTION,
        successCode: '',
        contactMailId: process.env.CONTACT_MAILID,
        statusCode: '',
        mailCheck: true,
        langCode: '',
        selfServiceGroup: ''
      }
    },
    components: {
      Spinner,
      VueRecaptcha
    },
    computed: {
    },
    watch: {
    },
    methods: {
      sendMessageToDatadog: function(msg, data) {
        let url = `${apiUrl}/dataDogMessage?message=${msg}`
        idmApi.sendMessageToDatadog(url, data).then(function (response) {
          console.log(response)
        }).catch(function (error) {
          console.log(error)
        })
      },
      getUserDetails: function() {
        var self = this
        let message = `User Details: Name - ${self.person.firstName} ${self.person.lastName}; Email - ${self.person.email}; Locale - ${self.person.locale}`
        if (self.person.firstName === '' || self.person.lastName === '' || self.person.email === '') {
          message = 'User Details: No values entered.'
        }
        return self.appId + ':' + message
      },
      updateCaptchaWithLocale: function () {
        // Get GoogleCaptcha iframe
        let iframeGoogleCaptcha = $('#captcha_container').find('iframe');
        let lang = common.getLanguage(this.langCode);
        if (lang === 'zh_TW') {
          lang = 'bg';
        }
        lang = lang.replace('_', '-');
        if (iframeGoogleCaptcha && iframeGoogleCaptcha.length > 0) {
          iframeGoogleCaptcha.attr("src", iframeGoogleCaptcha.attr("src").replace(/hl=(.*?)&/, 'hl=' + lang + '&'));
        }
      },
      getParameterByName: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        let results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },
      onVerify(resp) {
        let self = this;
        if (resp.length !== 0) {
          self.captchaVerified = true;
          let message = self.getUserDetails()
          self.sendMessageToDatadog('Verified ', message)
        }
      },
      onExpired(resp) {
        let self = this;
        self.captchaVerified = false;
        let message = self.getUserDetails()
        self.sendMessageToDatadog('Expired ', message)
      },
      onError(error) {
        let self = this;
        console.log(error)
        let message = self.getUserDetails()
        self.sendMessageToDatadog('Error', message)
      },
      onRender(id) {
        var self = this
        if (self.appId === self.appIdException && self.selfServiceGroup === self.groupIdException) {
          $('#captcha_container').css({
            display: "none",
            visibility: "hidden"
          })
          self.captchaVerified = true
        }
        setTimeout(function() {
          console.log('Render', id)
          window.grecaptcha.reset();
        }, 1000)
      },
      validEmail: function(email) {
        let re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
        return re.test(email);
      },
      validateSpecialCharacters: function(text) {
        return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(text); // eslint-disable-line
      },
      validateAndResendInvite() {
        let self = this;
        self.userValidations = '';
        if (self.person.firstName.trim() === '') {
          self.userValidations = self.user_lang['firstnamereq'];
        } else if (!this.validateSpecialCharacters(self.person.firstName.trim())) {
          self.userValidations = self.user_lang['noSpecialCharacters'];
        } else if (self.person.lastName.trim() === '') {
          self.userValidations = self.user_lang['lastnamereq'];
        } else if (!this.validateSpecialCharacters(self.person.lastName.trim())) {
          self.userValidations = self.user_lang['noSpecialCharacters'];
        } else if (self.person.email.trim() === '') {
          self.userValidations = self.user_lang['emailreq'];
        } else if (self.person.email.trim().toLowerCase().indexOf('@cargill.') > -1 || self.person.email.trim().toLowerCase().indexOf('@crgl-thirdparty.') > -1 || self.person.email.trim().toLowerCase().indexOf('@awb') > -1) {
          self.userValidations = self.user_lang['emailinvaliddomain'];
        } else if (!this.validEmail(self.person.email.trim())) {
          self.userValidations = self.user_lang['emailinvalid'];
        } else if (self.person.locale.trim() === '') {
          self.userValidations = self.user_lang['selectLang'];
        } else if (!self.captchaVerified) {
          self.userValidations = "Please verify captcha";
        } else {
          self.loading = true
          let message = self.getUserDetails()
          self.sendMessageToDatadog('Clicked Register button : ', message)
          self.person.firstName = self.person.firstName.trim()
          self.person.lastName = self.person.lastName.trim()
          self.person.email = self.person.email.trim()
          self.person.login = self.person.email;
          let data = {profile: self.person, groupIds: []};
          let url = '';
          if (self.selfServiceGroup !== '' && self.selfServiceGroup !== null) {
            url = `${apiUrl}/selfRegisterUser?appId=${self.appId}&selfServiceGroup=${self.selfServiceGroup}`;
          } else {
            url = `${apiUrl}/selfRegisterUser?appId=${self.appId}`;
          }
          idmApi.sendSelfRegistration(`${url}`, data).then(function (response) {
            self.inviteSuccess = true;
            if (response.data) {
              if (response.data.appEmailId !== undefined && response.data.appEmailId !== '') {
                self.contactMailId = response.data.appEmailId;
              }
              if (response.data.status !== undefined && response.data.status !== '') {
                self.contactMailId = self.person.email;
                self.successCode = response.data.status;
              }
              if (!self.validEmail(self.contactMailId)) {
                self.mailCheck = false;
              }
            }
            self.loading = false
          }).catch(error => {
            console.log(error)
            if (error.response && error.response.data) {
              if (error.response.data.errorCode) {
                self.successCode = error.response.data.errorCode;
                if (error.response.data.errorCode === 'E0003') {
                  self.contactMailId = self.person.email;
                }
              }
              if (error.response.data.appEmailId !== undefined && error.response.data.appEmailId !== '') {
                self.contactMailId = error.response.data.appEmailId;
              }
              if (error.response.data.errorSummary !== undefined && error.response.data.errorSummary !== '') {
                self.statusCode = error.response.data.errorSummary;
              }
              if (error.response.data.status !== undefined && error.response.data.status !== '') {
                self.contactMailId = self.person.email;
                self.successCode = error.response.data.status;
              }
              if (!self.validEmail(self.contactMailId)) {
                self.mailCheck = false;
              }
            }
            self.inviteSuccess = true;
            self.loading = false
          })
        }
      }
    }
  }
</script>
<style scoped>
.hiddden {
  visibility:hidden;
}
input {
  background: #fff;
}
input, select {
  height: 30px;
  color:#333;
  margin-top:2px;
}
label > input { /* HIDE RADIO */
  visibility: hidden; /* Makes input not-clickable */
  position: absolute; /* Remove input from document flow */
}
label > input + img { /* IMAGE STYLES */
  cursor:pointer;
  border:2px solid #ddd;
}
label > input:checked + img { /* (RADIO CHECKED) IMAGE STYLES */
  border:2px solid #333;
  border-radius:0px;
}
input, select {
  background: #fff;
  border: 2px solid #dde3e6!important;
  display: block !important;
  border-radius: 0px !important;
  min-height: 30px;
  padding-left: 5px;
}
input[type=button]:hover, button:hover {
  background-color: var(--theme-primary) !important;
  border: 1px solid var(--theme-primary) !important;
	color: var(--regpwd-secondarytextcolor) !important;
	border-radius: 0px !important;
}
input[type=button], button {  
  background-color: var(--theme-primary) !important;
  border-color: var(--theme-primary) !important;
	color: var(--regpwd-secondarytextcolor) !important;
	border-radius: 0px !important;
}
#selfRegistration, #selfRegistrationSucess {
  max-width: 394px;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
}
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
}
.splash {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: -1;
	object-fit: cover;
}
.disabled {
  pointer-events: none;
  opacity: 0.6
}
.validation-text {
  color: #bd0000;
  background: pink;
  border-radius: 3px;
  border: 1px solid #bd0000;
  padding: 5px 10px;
  margin: 10px 0px;
}
.okta-sign-in-header {
  padding: 10px 90px 10px 90px;
  position: relative;
  z-index: 10;
  transition: padding-bottom .4s;
}
.auth-org-logo {
  max-width: 120px !important;
  display: block;
  margin: 0 auto;
  max-height: 40px;
}
</style>



// WEBPACK FOOTER //
// SelfRegistration.vue?0deafa5c